
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';
    import { routers } from '@/router/router'
    import moment from 'moment'
    import storeaddressInfo from '@/store/entities/back-storeaddress-list'


    class AmountListRequest extends PageRequest {
        shipment: string;
        beginTime?: Date;
        endTime?: Date;
        storeId?: number;
    }


    @Component({
        name: "frontIntologisticsrecord",
    })
    export default class Orders extends AbpBase {
        pagerequest: AmountListRequest = new AmountListRequest();
        storeaddressList: Array<storeaddressInfo> = [];
        creationTime: Date[] = [];
        get list() {
            return this.$store.state.frontIntologistics.list;
        };
        get loading() {
            return this.$store.state.frontIntologistics.loading;
        }
        pageChange(page: number) {
            this.$store.commit('frontIntologistics/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('frontIntologistics/setPageSize', pagesize);
            this.getpage();
        }
        async getpage() {
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            if (this.creationTime.length > 0) {
                this.pagerequest.beginTime = this.creationTime[0];
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.endTime = this.creationTime[1];
            }
            await this.$store.dispatch({
                type: 'frontIntologistics/getAll',
                data: this.pagerequest
            });
        }

        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            var a = new storeaddressInfo();
            a.id = null;
            a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
            this.storeaddressList.push(a);
            this.pagerequest.storeId = null;

        }

        get pageSize() {
            return this.$store.state.frontIntologistics.pageSize;
        }
        get totalCount() {
            return this.$store.state.frontIntologistics.totalCount;
        }
        get currentPage() {
            return this.$store.state.frontIntologistics.currentPage;
        }
        async searchPage() {
            this.$store.state.frontIntologistics.currentPage = 1;
            this.getpage();
        }
        columns = [
            {
                title: '快递单号',
                width: 200,
                align: "center",
                key: 'shipment'
            },
            {
                title: '仓库名称',
                align: "center",
                width: 200,
                render: (h: any, params: any) => {
                    return h('span', params.row.warehouseName ? params.row.warehouseName : params.row.storeName)
                }
            },{
                title: '创建时间',
                key: 'creationTime',
                align: "center",
                width: 200,
                render: (h: any, params: any) => {
                    return h('span', DateUtils.formatLongDate(new Date(params.row.creationTime)));
                }
            }]
        async created() {
            await this.getData();
          //  this.getpage();
        }
    }
